
/**
 * @fileOverview AnchorController module definition
 * Last Modified: 6/9/2014
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/AnchorController',['require','lib/Util','jquery','GlobalEventDispatcher'],function (require) {

        var Util = require('lib/Util');
        var $ = require('jquery');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         * Jumps the page to the change location drawer and expands. Looks for presence of SETTINGS.updateLocationLinks and will append the current page HREF to the others to keep you on child pages in new site.
         *
         * @name AnchorController
         * @class AnchorController
         * @constructor
         * @param {jQuery} $element A reference to the containing DOM element

         */
        require(['domReady!'], function (doc) {
            /*Fires upon DOM Ready to initialize component*/
            new AnchorController();
        });
        var AnchorController = function () {
            this.$target = $('.js-triggerLink.MMM--localizationTrigger');
            this.$locationContainer = $('.MMM--localization-drawer.js-subNavDrawer');
            this.$locationLinks =[];
            this.triggerClass = 'MMM--localizationTrigger_isActive';
            this.targetActiveClass = 'MMM--localizationDrawer_isOpen';
            this.triggerOpen = undefined;

            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @name isEnabled
             * @type {bool}
             */
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * returns {AnchorController}
         */
        AnchorController.prototype.init = function() {
            $debug('***** Anchor Controls Init *****', 'anchorControls');
            this.isEnabled = false;

            this.createChildren()
                .setupHandlers()
                .enable()
                .updateLinks();
            return this;
        };

        AnchorController.prototype.createChildren = function () {
            var self=this;
            self.linkscontainer = self.$locationContainer.find($('ol.MMM--locationsMenu'));
            return this;
        };

        AnchorController.prototype.updateLinks = function () {
            var self = this,
                currPageURL = location.pathname, //get current URL
                startingPoint = '/3M/',      //constant delimiter before site root
                mmmPos,                      //position of starting point placeholder
                rootURLPos,                  //position of root URL start
                subPagePos,                  //position of subpage start
                localePos,                   //position of locale POS
                rootURLFrag,                 //root URL of site
                subPageFrag,                 //fragment url for page
                oldMethod = false;          //long urls contain portal or myportal

            if (SETTINGS.updateLocationLinks !== undefined){
                if (SETTINGS.updateLocationLinks === true){
                    $debug('   SETTINGS.updateLocationLinks set to true... updating all links', 'anchorControls');
                    //allow testing of specific url
                    if (SETTINGS.updateLocationLinksTestURL !== undefined){
                        currPageURL = SETTINGS.updateLocationLinksTestURL;
                        $debug('       Test URL Used! = ' + currPageURL, 'anchorControls');
                    }

                    //location.href will use parameters - where location.pathname does not
                    if (SETTINGS.locationLinkParameters === true){
                        $debug('       location Link parameters set to TRUE', 'anchorControls');
                    }
                    else {
                        $debug('       location Link parameters NOT set. note this is not compatible when using updateLocationsLinksTestURL as that will override the page URL', 'anchorControls');
                    }

                    //check and parse old method...
                    if (currPageURL.indexOf('/portal/') !== -1 || currPageURL.indexOf('/myportal/') !== -1){
                        //example: https://previewext.3m.com.tw/wps/portal/en_TW/3M/supplier-direct/subpage1
                        $debug('       Old URLS detected', 'anchorControls');
                        oldMethod = true;
                        startingPoint = '/3M/';
                        mmmPos = currPageURL.indexOf(startingPoint);        //get the position of /3M/
                        rootURLPos = currPageURL.indexOf('/', mmmPos + 1);  //get the position of next url section /supplier-direct/
                        subPagePos = currPageURL.indexOf('/', rootURLPos + 1); //get the position of next url section /subpage1
                    }
                    else {
                        //example: https://www.3m.com/3M/en_US/country-us/subpage1/
                        $debug('       New URLS detected', 'anchorControls');
                        mmmPos = currPageURL.indexOf(startingPoint);    //check for '/3M/'
                        if (mmmPos === -1){
                            mmmPos = currPageURL.indexOf('/my3M/');     //if -1, check for /my3M/
                        }
                        localePos = currPageURL.indexOf('/', mmmPos + 1);  //get the position of next url section (/en_US)
                        rootURLPos = currPageURL.indexOf('/', localePos + 1);  //get the position of next url section (/country-us)
                        subPagePos = currPageURL.indexOf('/', rootURLPos + 1); //get position of next url section (subpage1)
                    }

                    rootURLFrag = currPageURL.substring(rootURLPos + 1, subPagePos);    //finds root URL fragment (/country-us)
                    subPageFrag = decodeURIComponent(currPageURL.substring(subPagePos + 1));                //finds sub page URL fragment (/subpage1)

                    $debug('       Root URL = ' + rootURLFrag, 'anchorControls');
                    $debug('       Sub Page Fragment = ' + subPageFrag, 'anchorControls');
                    if (subPageFrag !== ''){    //only run if not on homepage
                        self.linkscontainer.find('li a').each(function(i,e){
                            e.href = e.pathname + subPageFrag; //update the link paths
                        });
                    }
                }
                else {
                    $debug('   SETTINGS.updateLocationLinks set, but equals: ' + SETTINGS.updateLocationLinks, 'anchorControls');
                }
            }
            else {
                $debug('   SETTINGS.updateLocationLinks not set', 'anchorControls');
            }

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * returns {AnchorController}
         */
        AnchorController.prototype.setupHandlers = function () {
            // Bind event handlers scope here
            var self = this;

            $('a.js-changelocation, a[href="#changeLocation"]').on('click', function (e) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                else {
                    //needed for IE Support
                    e.returnValue = false;
                }
            });

            return this;
        };

         /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {AnchorController}
         */
        AnchorController.prototype.enable = function () {
            var self = this;
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            //test to see if already open
            if (self.$locationContainer.hasClass(self.targetActiveClass)){
                self.triggerOpen = true;
            }
            else {
                self.triggerOpen = false;
            }

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {AnchorController}
         */
        AnchorController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @returns {AnchorController}
         */
        AnchorController.prototype.destroy = function () {
            this.disable();
            return this;
        };

        return AnchorController;
    });
}(MMMRequire));

